module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-menu greal-left"
  }, [_c('el-row', {
    staticClass: "tac",
    attrs: {
      "sysName": _vm.sysName
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.active,
      "text-color": "#000",
      "router": true,
      "collapse-transition": true,
      "unique-opened": true,
      "active-text-color": "#fff"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-menu-item', {
    attrs: {
      "route": {
        name: 'Software'
      },
      "index": "Software"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticClass: "jump Difjump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("软件概述")])])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'RunEnvironment'
      },
      "index": "RunEnvironment"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticClass: "jump Difjump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("运行环境")])])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'UserMessage'
      },
      "index": "UserMessage"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticClass: "jump Difjump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("用户注册与登录")])])]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "ImageHospital"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("资料中心")])]), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "route": {
        name: 'ImageHospital'
      },
      "index": "ImageHospital"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("本院影像")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'TypicalBank'
      },
      "index": "TypicalBank"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("典型病例库")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'TeachWare'
      },
      "index": "TeachWare"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("教学课件")])])], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "DailyReading"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("读片管理")])]), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "route": {
        name: 'DailyReading'
      },
      "index": "DailyReading"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("每日读片")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'ThematicReading'
      },
      "index": "ThematicReading"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("专题读片")])])], 1)], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'ManageTeach'
      },
      "index": "ManageTeach"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticClass: "jump Difjump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("教学管理")])])]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "ExcellentCourse"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("教学中心")])]), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "route": {
        name: 'ExcellentCourse'
      },
      "index": "ExcellentCourse"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("精品好课")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'ThematicRead'
      },
      "index": "ThematicRead"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("名师讲堂")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'MyCollection'
      },
      "index": "MyCollection"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("我的收藏")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'Mylearn'
      },
      "index": "Mylearn"
    }
  }, [_c('a', {
    staticClass: "jump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("我的学习")])])], 1)], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": {
        name: 'Audio'
      },
      "index": "Audio"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticClass: "jump Difjump",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("音视频")])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-62cbe68a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/helpMenu/helpMenu.vue
// module id = 572
// module chunks = 1 2 3 4 5 6 7 8